export default __webpack_public_path__ + "static/media/pexels-pixabay-855645-1920x1080-24fps.d60f2ecb.mp4";